import React from 'react'

import Navbar from '../Components/Navbar'
import PipesDetails from '../Components/PipesDetails'
import Footer from '../Components/Footer'

const SeamlessPipes = () => {
  return (
    <div>
      <Navbar />
      <PipesDetails />
      <Footer />
    </div>
  )
}

export default SeamlessPipes